import React from 'react';


import classNames from "classnames";
import {observer} from "mobx-react";
import styles from "../../styles/entity-scores-widget.module.scss";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {EntityScoresWidgetNavigationButtonsResults} from "./entity-scores-widget.navigation-buttons.results";
import {EntityScoresWidgetNavigationButtonsFixture} from "./entity-scores-widget.navigation-buttons.fixture";

export class EntityScoresWidgetNavigationButtonsProps extends BaseProps {}

export const EntityScoresWidgetNavigationButtons = observer(({controller, onFilterChange}: EntityScoresWidgetNavigationButtonsProps) => {
  const {state} = controller;
  const {entityContext} = state;
  const {shouldRenderNavigationButton} = entityContext;

  return (
    shouldRenderNavigationButton ? <div className={classNames(styles.navigation_buttons)}>
      <EntityScoresWidgetNavigationButtonsResults controller={controller} onFilterChange={onFilterChange}/>
      <EntityScoresWidgetNavigationButtonsFixture controller={controller} onFilterChange={onFilterChange}/>
    </div> : null
  )
});

